<template>
  <div class="commitment-config-wizard">
  <el-form size="fat" label-position="top" @submit.native.prevent>
    <el-card v-if="!isNewCommitment && !own_commitment">
      This commitment belongs to another user.
    </el-card>

    <!--
    <div v-if="commitmentForm.type && step !== 'basics'">
      <h3 class="text-center">You're creating a '{{commitmentForm.type}}'</h3>
      <img
      class="fat-checkbox__image"
      :src="commitment_types.find(item => item.id === commitmentForm.type ).src"
      width="48" />
      <div class="fat-checkbox__text">
        {{commitment_types.find(item => item.id === commitmentForm.type ).text}}
      </div>
    </div>
    -->

    <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
    <div v-if="step === 'basics'">

      <!-- TODO: commitment -> goal -->

      <info-box title="What is a commitment?">
        A commitment is <strong>something very specific</strong> you wanna do
        about your goal in order to achieve it. It’s kinda like glue between
        what you want and what you have to do.... like concrete steps and stuff.
        <el-tooltip :content="`This commitment will be created in ${goal_meta.name}`">
          <img src="@/assets/wizard/commitment_info.svg" class="pt-4 mx-8" />
        </el-tooltip>
      </info-box>

      <el-form-item label="Short description or name">
        <el-input size="fat" v-model="commitmentForm.meta.name" placeholder="My new commitment" autofocus></el-input>
      </el-form-item>

      <el-form-item label="Select type of commitment">
        <el-radio-group v-model="commitmentForm.type" class="fat-flex-group">
          <el-radio
            v-for="type in commitment_types"
            :key="type.id"
            v-model="type.checked"
            :label="type.id"
            :disabled="type.disabled"
            border
            class="fat-checkbox">
            <img class="fat-checkbox__image" :src="type.src" width="48" />
            <div class="fat-checkbox__text">{{type.text}}</div>
          </el-radio>
        </el-radio-group>
      </el-form-item>

      <info-box title="What does that mean?" v-if="commitmentForm.type">
        <template v-if="commitmentForm.type === 'TASKLIST'">
          Explain here VERY CLEARLY what this setting means and does. What are the benefits of each setting?
        </template>
        <template v-if="commitmentForm.type === 'TIME_BASED_TASKLIST'">
          TIME is...
        </template>
        <template v-if="commitmentForm.type === 'HABIT'">
          HABIT is...
        </template>
        <template v-if="commitmentForm.type === 'SEQUENCE'">
          SEQUENCE is...
        </template>
        <template v-if="commitmentForm.type === 'AMOUNT'">
          AMOUNT is...
        </template>
      </info-box>

      <el-form-item label="How many hours do you want to spend?" v-if="commitmentForm.type === 'TIME_BASED_TASKLIST'">
        <el-input v-model="committedTimeInHours" type="number" :min="0" />

        <duration-quick-settings
          v-model="commitmentForm.committedTime"
          :quickDurationSettings="committedTimeOptions">
        </duration-quick-settings>
      </el-form-item>

      <!-- IDEA: Maybe use icon instead of image -->

      <el-form-item label="Motto Picture">
        <image-selector-mini
          v-model="commitmentForm.picture"
          content="commitment"
          bucket="commitment_pics"
          :suggestion-text="commitmentForm.meta.name" />
        <!--
        <div style="display: flex; flex-direction: column">
          <div>
            <ImageUpload
              v-model="commitmentForm.picture"
              :searchText="commitmentForm.meta.name"
              bucket="commitment_pics" />
          </div>
        </div>
        -->
      </el-form-item>
    </div>

    <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
    <div v-if="step === 'responsibility' && commitmentForm">

      <el-form-item label="Who will be resposible?">
        <el-radio-group v-model="wizard.responsibility" class="fat-flex-group">
          <el-radio-button label="ME" border>
            <font-awesome-icon icon="user" /> I am
          </el-radio-button>
          <el-radio-button label="OTHER" border>
            <font-awesome-icon icon="users" /> Somebody else is
          </el-radio-button>
        </el-radio-group>
      </el-form-item>
      <!-- TODO: make sure = $models.user.defaultUserId -->

        <el-form-item
          label="Please select a person, who will be resposible:"
          v-if="wizard.responsibility === 'OTHER'">
          <!-- TODO: move to component userselect -->
          <!-- TODO: When i seelct myself change above -->
          <el-select
            class="w-50"
            popper-class="el-popper--fat"
            v-if="goal_members.$readySome"
            v-model="commitmentForm.meta.assignedUserId"
            placeholder="Schedule when?">
            <el-option
              v-for="member in goal_members.items"
              :key="member.$key"
              :label="member.cachedName"
              :value="member.$id">
              <img class="user-mini-image"
                :src="member.cachedProfilePic|defaultUserPic"
                style="border-radius: 100%"
                width="32"
                height="32"
                :title="member.cachedName" />
              {{member.cachedName}}
            </el-option>
          </el-select>
        </el-form-item>

      <div style="display: flex; justify-content: space-between;">
        <el-form-item
          style="flex: 0 0 50%; padding-right: 1em"
          v-if="wizard.responsibility === 'ME'">

          <template slot="label">
            What time would be best to work on this?<br/>
            Please select a schedule
          </template>

          <el-radio-group
            class="timeslot-collection-radio-group"
            v-model="commitmentForm.user.timeslotCollectionId">
            <el-radio
              v-for="item in timeslotCollectionsSelectOptions"
              :key="item.value"
              :label="item.value"
              :style="{ width: '100%', color: item.color }">
              {{item.label}}
            </el-radio>
            <!-- TODO: Also allow 'use default'? -->
          </el-radio-group>

          <div v-if="defaultTimeslotCollectionId === commitmentForm.user.timeslotCollectionId" class="h5">
            (Default schedule)
          </div>
        </el-form-item>

        <el-form-item
          style="flex: 0 0 50%"
          v-if="wizard.responsibility === 'ME' && commitmentForm.user.timeslotCollectionId">
          <template slot="label">
            How important is this to you?<br/>
            Please select a priority
          </template>
          <el-select
            v-model="commitmentForm.user.prioidx"
            popper-class="el-popper--fat"
            placeholder="Prio.">
            <el-option
              v-for="item in prioSelectOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </div>

    <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
    <div v-if="step === 'planning'">

      <info-box title="">
        <template v-if="commitmentForm.type === 'TIME_BASED_TASKLIST'">
          You committed <strong>{{Math.round( commitmentForm.committedTime / 3600 )}} hours</strong> to get closer to your goal “{{goal_meta.name}}”.
          Now let’s see how you can get there!
          <img src="@/assets/wizard/exmplainer_planning_1.svg" class="pt-4" />
        </template>
        <template v-if="commitmentForm.type === 'TASKLIST'">
          Currently this goal has <strong>{{goal_num_of_tasks}} tasks</strong> which accumulat to a total of <strong>{{goal_accumulated_hours}} hours</strong>.
        </template>
      </info-box>

      <el-form-item label="When do you want to start working on this?">
        <date-selector
          style="width: 30%; float: left;"
          v-model="commitmentForm.startDate"
          type="date"
          @focus="wizard.start_setting = null"
          :class="{ 'is-active': wizard.start_setting === null }"
          placeholder="First Day">
        </date-selector>

        <el-radio-group v-model="wizard.start_setting" style="width: 69%; display: inline-flex;">
          <el-radio-button label="ASAP" border class="pl-6">As soon as possible</el-radio-button>
          <el-radio-button label="LATER" border class="pl-6">I'll decide later</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="When do you wanna finish?">
        <date-selector
          style="width: 30%; float: left;"
          v-model="commitmentForm.endDate"
          type="date"
          @focus="wizard.end_setting = null"
          :class="{ 'is-active': wizard.end_setting === null }"
          placeholder="Last Day">
        </date-selector>

        <el-radio-group v-model="wizard.end_setting" style="width: 69%; display: inline-flex;">
          <el-radio-button label="WHEN_DONE" border class="pl-6">Whenever it’s done</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="How many hours do you want to spend on this every day?">
        <el-input
          style="width: 30%; float: left;"
          v-model="committedTimeDailyInHours"
          @focus="wizard.committing_daily = null"
          :class="{ 'is-active': wizard.committing_daily === null }"
          :min="0"
          type="number" />

        <el-radio-group v-model="wizard.committing_daily" style="width: 69%; display: inline-flex;">
          <el-radio-button label="UNKNOWN" border class="pl-6">I don’t know yet</el-radio-button>
        </el-radio-group>

        <div v-if="commitmentForm.type === 'TIME_BASED_TASKLIST' && recommendedHoursPerDay">
          Based on start and finish date, we recommend at least
          <a href="#" @click.prevent="committedTimeDailyInHours = recommendedHoursPerDay.hours"><strong>~ {{recommendedHoursPerDay.hours}}h</strong></a>
          ({{recommendedHoursPerDay.days}} days).
        </div>

        <duration-quick-settings
          v-model="commitmentForm.committedTimeDaily"
          :quickDurationSettings="committedTimeDailyOptions">
        </duration-quick-settings>
      </el-form-item>

      <el-form-item label="Please select a planning strategy.">
        <el-radio-group v-model="wizard.planning_strategy" style="float: left; width: 50%;">
          <el-radio-button label="MANUALLY" border class="">
            Plan manually
          </el-radio-button>
          <el-radio-button label="AUTOMATIC" border class="">
            <font-awesome-icon icon="cog" />
            Automatically plan every day
          </el-radio-button>
        </el-radio-group>
        <info-box title="Planning strategy" style="float: right; width: 45%;">
          We will automatically plan <strong>{{wizard.committing_daily}}h every day</strong>,
          whenever there is a free spot in your schedule <strong>“{{timeslotCollectionsSelectOptions.find(option => commitmentForm.user.timeslotCollectionId == option.value).label}}”</strong>.
        </info-box>
      </el-form-item>
      <a href="#" @click.prevent>Show more options</a>

      <!--
      <el-form-item label="Commitment status">
        <el-radio-group v-model="commitmentForm.meta.active" >
          <el-radio :label="true" border>Active (default)</el-radio>
          <el-radio :label="false" border>Inactive / Paused</el-radio>
        </el-radio-group>
      </el-form-item>
      -->
    </div>

    <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
    <div v-if="step === 'routine'">
      <el-form-item label="Please select a routine from your routine templates.">
        <el-select
          v-model="commitmentForm.sequenceId"
          popper-class="el-popper--fat"
          placeholder="Select a routine..."
          class="w-100">
          <el-option
            v-for="item in sequenceSelectOptions"
            :key="item.value"
            :value="item.value"
            :label="item.label"
            style="height: 50px; border-bottom: 1px solid rgb(232, 232, 232);">
            <strong style="line-height: 23px; padding-top: 2px; display: block;">{{item.label}}</strong>
            <p class="p-0 m-0" style="line-height: 20px">{{item.description}} <span v-if="item.length">({{item.length}} items)</span></p>
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="How many times do you want to repeat this routine?">
        <el-input
          type="number"
          style="width: 30%; float: left;"
          v-model="commitmentForm.templateRepeat"
          @focus="wizard.sequence_repeat_setting = null"
          :class="{ 'is-active': wizard.sequence_repeat_setting === null }"
          :min="0"
          :step="1" />

        <el-radio-group v-model="wizard.sequence_repeat_setting" style="display: inline-flex;">
          <el-radio-button label="ONCE" border class="pl-6">Only once</el-radio-button>
          <el-radio-button label="INFINITELY" border class="pl-6">Infinitely until I die</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="How do you wanna handle missed sessions?">
        <el-radio-group v-model="commitmentForm.allowSessionToBeSkipped">
          <el-radio :label="false">
            <span style="font-size: 16pt">Finish all items in routine in planned order. Reschedule missed sessions.</span>
          </el-radio>
          <el-radio :label="true">
            <span style="font-size: 16pt">Skip items when missed. Results in a fixed duration of the routine.</span>
          </el-radio>
        </el-radio-group>
      </el-form-item>

      <info-box title="What does that mean?" >
        Explain here...
      </info-box>
    </div>

    <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
    <div v-if="step === 'habit'">

      <info-box title="What does that mean?" style="float: right; width: 200px">
        Explain here...
      </info-box>

      <el-form-item label="What kind of habit do you want to develop?">
        <el-radio-group
          v-model="commitmentForm.habitNegation">
          <el-radio class="d-block" label="DO">Do something</el-radio>
          <el-radio class="d-block" label="DONT">Don't do something</el-radio>
        </el-radio-group>
      </el-form-item>

      <div style="display: flex">
        <el-form-item label="How often do you wanna do it?" style="flex: 0 0 50%;">
          <el-select
            v-model="commitmentForm.habitRepeatPattern"
            popper-class="el-popper--fat"
            placeholder="Select one...">
            <el-option
              v-for="item in habitRepeatOptions"
              :key="item.value"
              :value="item.value"
              :disabled="item.disabled"
              :label="item.label">
              <strong>{{item.label}}</strong>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="How many times per day?" style="flex: 0 0 50%;">
          <el-input
            type="number"
            v-model="commitmentForm.habitRepeatDaily"
            :min="1"
            :step="1" />
        </el-form-item>
      </div>

      <!-- TODO: commitmentForm.habitWeekdays -->

      <el-form-item label="What do you want to do every day">
        <el-input size="fat" v-model="commitmentForm.meta.name" placeholder="My new commitment" autofocus></el-input>
      </el-form-item>

      <info-box title="The 21 day myth">
        On average, it takes more than 2 months before a new behavior becomes automatic — 66 days to be exact.
        And how long it takes a new habit to form can vary widely depending on the behavior,
        the person, and the circumstances.<br />
        <a href="#" @click.prevent="wizard.habit_show_more = !wizard.habit_show_more">show more</a>
      </info-box>

      <info-box title="Eight Tips to Creating a Good Habit" v-if="wizard.habit_show_more">
        <!-- SOURCE: https://www.the1thing.com/blog/the-one-thing/the-21-days-to-build-a-habit-myth -->
        <ol>
          <li><strong>Do it ONE Thing at a time.</strong> When we focus on forming just one habit, the likelihood of sticking to it and turning a behavior into a synaptic habit pathway is greatly improved.</li>
          <li><strong>Track your progress.</strong> Habit-forming tools such as <del>the My ONE Thing Tracker</del> <em>Goalpilot</em> allow you to track your progress and stay on task.</li>
          <li><strong>Be extremely consistent in the beginning.</strong> Studies show that consistency pays off, particularly in the beginning of creating a habit when automaticity increases are at their highest.</li>
          <li><strong>Don’t stop if it seems to be taking too.</strong> Many people fail because they give up too early. Remember, there is no set time limit on forming a habit.</li>
          <li><strong>Keep motivational reminders on hand.</strong> At the beginning when whatever inspired the new habit is fresh on the mind it’s easy to put in the work. But as time passes the inspiration starts to fade. Motivational reminders will help to drive you through the uphill climb to habit formation.</li>
          <li><strong>Visualize the rewards of establishing the new habit.</strong>  Whenever you feel yourself waning or falling back into a bad habit, imagine how much better things will be now and in the future because of the new habit.</li>
          <li><strong>Create a positive parallel pattern.</strong> The synaptic habit pathway never fully goes away, which means it can easily be triggered. Instead of just quitting a bad habit, replace it with a new parallel pattern for the habit-related situation.</li>
          <li><strong>Minimize disruptions when starting a new habit.</strong> If you have a vacation right around the corner, are in the middle of a move or are experiencing any other hurdles in your regular routine,  now is not the time to start trying to form a new habit.</li>
        </ol>
      </info-box>

    </div>

    <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
    <div v-if="step === 'amount'">
      <info-box title="What does that mean?" style="float: right; width: 200px">
        Explain here...
      </info-box>

      <el-form-item label="What commitment do you want to define?">
        <el-radio-group
          v-model="commitmentForm.amountType">
          <el-radio class="d-block" label="MONEY">Save a certain amount of money</el-radio>
          <el-radio class="d-block" label="WEIGHT">Loose or gain weight</el-radio>
          <el-radio class="d-block" label="WATER">Drink certain amount of water</el-radio>
          <el-radio class="d-block" label="OTHER">Something else</el-radio>
        </el-radio-group>
      </el-form-item>

      <div style="display: flex">
        <el-form-item label="How much do you have now?" style="flex: 0 0 40%;">
          <el-input
            type="number"
            v-model="commitmentForm.amountCurrent">
            <template slot="append">{{amount_unit}}</template>
          </el-input>
        </el-form-item>
        <div style="align-self: center; margin: 0 auto; margin-top: 2em;">
          <font-awesome-icon icon="arrow-right" size="3x" />
        </div>
        <el-form-item label="How much do you want to have?" style="flex: 0 0 40%;">
          <el-input
            type="number"
            v-model="commitmentForm.amountTarget">
            <template slot="append">{{amount_unit}}</template>
          </el-input>
        </el-form-item>
      </div>
    </div>
    <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->

    <div class="wizard-buttons pt-6">
      <el-button v-if="navigation.show_back" size="fat" @click="onClickBack"> &larr; Go back</el-button>
      <el-button v-if="step === 'basics'" size="fat" @click="onDone">Cancel</el-button>
      <el-button v-if="navigation.show_create" size="fat" type="primary" @click="onClickSaveOrCreate" :disabled="navigation.disable_create">Create</el-button>
      <el-button v-if="navigation.show_next" size="fat" type="primary" @click="onClickNext" :disabled="navigation.disable_next"> Next &rarr;</el-button>
    </div>

    <hr v-if="SHOW_DEBUG" />
    <pre v-if="SHOW_DEBUG" class="mini-pre">step: {{step}}</pre>
    <pre v-if="SHOW_DEBUG" class="mini-pre">wizard: {{wizard}}</pre>
    <pre v-if="SHOW_DEBUG" class="mini-pre">{{commitmentForm}}</pre>
    <pre v-if="SHOW_DEBUG" class="mini-pre">{{navigation}}</pre>

    <!--
    <template v-if="commitmentForm.type !== 'BACKLOG'"></template>
    <template v-if="commitmentForm.type === 'TASKLIST'"></template>
    <template v-if="commitmentForm.type === 'BACKLOG'"></template>
    <template v-if="commitmentForm.type === 'MAGICLIST'"></template>
    <template v-if="commitmentForm.type === 'TRELLO'"></template>
    -->

  </el-form>
  </div>
</template>

<script>
import moment from '@/moment-gp'
import { MAGIC_UID_TEAM } from '@/api/task'
import { COMMITMENT_TYPES } from './types'

// TODO: is more imporant then “...” instead of prio
// TODO: Who will be responsible raus bei !isTeamgoal

export default {
  props: {
    isNewCommitment: { required: true },
    goalId: { required: true },
    commitmentId: { required: true },
    memberId: { required: true },
    // tscId: { default: null },
    newType: {},
  },
  data: () => ({
    step: 'basics',
    last_steps: ['basics'],
    navigation: {
      show_cancel: true,
      show_back: false,
      show_next: true,
      disable_next: true,
      show_create: true,
      disable_create: true,
    },
    wizard: {
      responsibility: 'ME',
      start_setting: 'ASAP',
      end_setting: 'WHEN_DONE',
      committing_daily: null,
      planning_strategy: 'MANUALLY',
      sequence_repeat_setting: 'ONCE',
      habit_show_more: false,
    },
    // show_manual_input_committed_hours: false,
    // show_manual_input_hours_per_day: false,
    commitmentForm: {},
    commitment_types: COMMITMENT_TYPES,
  }),
  created() {
    this.resetConfig();
    this.commitmentForm.type = this.newType;
  },
  watch: {
    commitmentId: {
      handler(commitmentId) {
        console.log("WATCHER commitmentId", commitmentId);
        if ( commitmentId && commitmentId !== 'PLACEHOLDER' ) {
          this.initConfigExistingCommitment()
        } else {
          this.resetConfig();
        }
      },
      immediate: true
    },
    navigation_enable_next(v)   { this.navigation.disable_next = !v },
    navigation_enable_create(v) { this.navigation.disable_create = !v },
    navigation_show_next(v)     { this.navigation.show_next = v },
    navigation_show_back(v)     { this.navigation.show_back = v },
  },
  computed: {
    timeslot_collection_list() {
      return this.$models.timeslotCollection.getList().itemsAsArray();
    },

    sessionLengthSelectOptions() {
      return [
        { value: 5,   label: '5 min',  disabled: true },
        { value: 10,  label: '10 min', disabled: true },
        { value: 15,  label: '15 min', disabled: false },
        { value: 20,  label: '20 min', disabled: true },
        { value: 25,  label: '25 min', disabled: true },
        { value: 30,  label: '30 min', disabled: false },
        { value: 60,  label: '1 h',    disabled: false },
        { value: 90,  label: '1 h 30 min',    disabled: false },
        { value: 120, label: '2 h',    disabled: false },
        { value: 180, label: '3 h',    disabled: false },
        { value: 240, label: '4 h',    disabled: false },
        { value: 300, label: '5 h',    disabled: false },
        { value: 360, label: '6 h',    disabled: false },
        { value: 'custom', label: 'custom', disabled: true }
      ];
    },

    habitRepeatOptions() {
      return [
        { value: 'EVERY_DAY',     label: 'every day',         disabled: false },
        { value: 'EVERY_2ND_DAY', label: 'every second days', disabled: true },
        { value: 'SPECIFIC_DAY',  label: 'on specific days of the week',  disabled: true },
        { value: 'EVERY_WEEK',    label: 'every week',        disabled: true },
        { value: 'EVERY_MONTH',   label: 'every month',       disabled: true },
      ];
    },

    committedTimeDailyOptions() {
      return {
        '0 min': 0 * 60,
        '5 min': 5 * 60,
        '10 min': 10 * 60,
        '15 min': 15 * 60,
        '20 min': 20 * 60,
        '25 min': 25 * 60,
        '30 min': 30 * 60,
        '45 min': 45 * 60,
        '1 h': 1 * 60 * 60,
        '2 h': 2 * 60 * 60,
        '3 h': 3 * 60 * 60,
        '4 h': 4 * 60 * 60,
        '5 h': 5 * 60 * 60,
        '6 h': 6 * 60 * 60,
        '7 h': 7 * 60 * 60,
        '8 h': 8 * 60 * 60,
      };
    },

    committedTimeOptions() {
      return {
        '0 h': 0 * 60,
        '1 h': 60 * 60,
        '2 h': 120 * 60,
        '3 h': 180 * 60,
        '4 h': 240 * 60,
        '5 h': 300 * 60,
        '10 h': 600 * 60,
        '15 h': 900 * 60,
        '20 h': 1200 * 60,
        '30 h': 1800 * 60,
        '40 h': 2400 * 60,
        '50 h': 3000 * 60,
        '75 h': 4500 * 60,
        '100 h': 6000 * 60,
        '500 h': 30000 * 60,
        '1.000 h': 60000 * 60,
        '5.000 h': 300000 * 60,
        '10.000 h': 600000 * 60
      };
    },

    amount_unit() {
      switch ( this.commitmentForm.amountType ) {
        case "MONEY":  return 'USD';
        case "WEIGHT": return 'kg';
        case "WATER":  return 'Liter';
        case "OTHER":  return '?';
        default: return '?';
      }
    },

    own_commitment() {
      return ( this.commitmentForm.meta.assignedUserId === this.$models.user.defaultUserId
            || this.commitmentForm.meta.assignedUserId === MAGIC_UID_TEAM )
    },

    user_goal_settings() {
      return this.$models.userGoalSettings.getNode( this.goalId )
    },

    goal_meta() {
      return this.$models.goalMeta.getNode( this.goalId )
    },

    goal_members() {
      return this.$models.goalMember.with({ goalId: this.goalId }).getList();
    },

    // <MOVE TO MIXIN> and use for kanban stats
    goal_tasklist() {
      if ( !this.$api.get_ready('tasks', this.goalId ) ) {
        return [];
      }

      let all_tasklists = this.$models.task
        .with({ goalId: this.goalId })
        .getters
        .lane_task_list_all_users

      let listflat = [];
      for ( let idx in all_tasklists ) {
        listflat.push( ...all_tasklists[ idx ].filter(task => !task.deleted && !task.done ) )
      }

      // console.log("listflat", listflat)
      return listflat;
    },

    goal_num_of_tasks() {
      return this.goal_tasklist.length;
    },

    goal_accumulated_hours() {
      let sum_of_seconds = this.goal_tasklist.reduce((v,p) => p.durationRemaining + v, 0)
      return Math.round( sum_of_seconds / 3600 );
    },
    // </MOVE TO MIXIN>

    defaultTimeslotCollectionId() {
      let categories = this.$models.userGoalCategory.getList().itemsSorted;
      if ( this.user_goal_settings.categoryId ) {
        let category = categories.find(category => category.$id === this.user_goal_settings.categoryId)
        return category.defaultTimeslotCollectionId || null
      }
      return null
    },

    timeslotCollectionsSelectOptions() {
      let timeslotCollectionList = this.timeslot_collection_list.map(item => {
        return { value: item.$id, label: item.name, color: item.color }
      });
      // let neverEntry = { value: null, label: '<Do not schedule / I will manually schedule.>', color: '#888888' };
      let neverEntry = { value: null, label: "<I'll decide later>", color: '#888888' };
      // let newEntry = { value: '<new>', label: '<New schedule>', color: '#000000' };
      return [ ...timeslotCollectionList, neverEntry ];
    },

    prioSelectOptions() {
      if ( this.commitmentForm.user.timeslotCollectionId ) {
        // TODO: fetch all commitment in this TSC
        // HACK:
        return [
          { value: 0, label: '1 (most important)' }, // "more important then ..."
          { value: 1, label: '2' },
          { value: 2, label: '3' },
        ]
      }
      return []
    },

    sequenceSelectOptions() {

      let userId = this.$models.user.defaultUserId;
      let sequenceList = this.$models.sequence.subscribeQuery({ key: 'owner', value: userId }).asArraySorted();
      // let sequenceList = this.$models.sequence.subscribeList().asArraySorted();

      let sequenceListOptions = sequenceList.items.map( sequence => {
        return {
          value: sequence.$id,
          label: sequence.name,
          description: sequence.description,
          length: ( sequence.sequenceItemList || []).length,
        }
      })
      sequenceListOptions.push({
        value: 'NEW',
        label: '<create new>',
        description: 'Create a new sequence after saving.',
        length: null
      })
      return sequenceListOptions;
    },

    committedTimeInHours: {
      get() {return this.commitmentForm.committedTime / 3600; },
      set(v) {this.commitmentForm.committedTime = v * 3600; }
    },

    committedTimeDailyInHours: {
      get() {return this.commitmentForm.committedTimeDaily / 3600; },
      set(v) {this.commitmentForm.committedTimeDaily = v * 3600; }
    },

    recommendedHoursPerDay() {
      let startDate = this.wizard.start_setting === "ASAP"
                    ? moment.currentDate()
                    : this.commitmentForm.startDate

      if ( startDate
        && this.commitmentForm.endDate
        && this.wizard.start_setting !== 'LATER'
        && this.wizard.end_setting === null
      ) {
        const factor = 1.5; // Magic factor
        const dt = this.commitmentForm.endDate.diff( startDate, 'days');
        const t_total = this.commitmentForm.committedTime / 3600

        return {
          hours:  Math.round( factor * t_total / dt ),
          days:   dt,
          factor: factor,
        }
      }
      return false;
    },

    navigation_show_back() {
      return ( this.step !== 'basics' );
    },

    navigation_show_next() {
      if ( this.step === 'planning'
        || this.step === 'routine'
        || this.step === 'habit'
        || this.step === 'amount' ) {
        return false
      }
      return true
    },

    navigation_enable_create() {
      if ( this.commitmentForm.type === 'TASKLIST'
        || this.commitmentForm.type === 'TIME_BASED_TASKLIST' ) {
        return !!this.commitmentForm.meta.name
      }
      if ( this.commitmentForm.type === 'HABIT' ) {
        return this.step === 'habit'; // HACK
      }
      if ( this.commitmentForm.type === 'SEQUENCE' ) {
        return !!this.commitmentForm.sequenceId
      }
      if ( this.commitmentForm.type === 'AMOUNT' ) {
        return !!this.commitmentForm.amountType; // HACK
      }
      return false
    },

    navigation_enable_next() {
      // STEP 1:
      if ( this.step === 'basics' ) {
        // TODO: Check if hours are valid when TIME is selected
        return ( this.commitmentForm.meta.name &&  this.commitmentForm.type )
      }
      if ( this.step === 'responsibility' ) {
        if ( this.wizard.responsibility === 'ME' ) {
          return true // !!this.commitmentForm.user.timeslotCollectionId
        }
        if ( this.wizard.responsibility === 'OTHER' ) {
          return !!this.commitmentForm.meta.assignedUserId
        }
      }
      return false;
    },
  },
  methods: {
    onClickNext() {
      this.last_steps.push( this.step );
      switch ( this.step ) {
        case 'basics':
          this.initConfigNewCommitment() // TODO: Reset when type is canged?

          switch ( this.commitmentForm.type ) {
            case "TASKLIST":             this.step = 'responsibility'; break;
            case "TIME_BASED_TASKLIST": this.step = 'responsibility'; break;
            case "HABIT":                this.step = 'habit'; break;
            case "SEQUENCE":             this.step = 'routine'; break;
            case "AMOUNT":               this.step = 'amount'; break;
          }
        break

        case 'responsibility':
         this.step = 'planning';
        break

        case 'routine':
          this.step = 'responsibility';
        break

        case 'habit':
          this.step = 'planning';
        break

        case 'amount':
          this.step = 'planning';
        break

        case 'planning':
          // Done
        break
      }
    },

    onClickBack() {
      this.step = this.last_steps.pop();
    },

    onDone() {
      this.$emit('done')
      this.resetConfig();
      // TODO: Delete Image if commitment was not created
    },

    initConfigNewCommitment() {
      console.log("initConfigNewCommitment");

      // let backupForm = Object.assign({}, this.commitmentForm);
      let backupForm = {
        meta: { name: this.commitmentForm.meta.name },
        picture: this.commitmentForm.picture,
        committedTime: this.commitmentForm.committedTime,
      }
      console.log("backupForm", JSON.stringify(backupForm, null, 2) )

      this.commitmentForm = this.$api.commitment_model_new({
        type:    this.commitmentForm.type,
        goal_id: this.goalId
      })

      this.commitmentForm.meta.name = backupForm.meta.name;

      if ( this.commitmentForm.type === 'TIME_BASED_TASKLIST' && backupForm.committedTime ) {
        this.commitmentForm.committedTime = backupForm.committedTime;
      }

      if ( backupForm.picture ) {
        this.commitmentForm.picture = backupForm.picture;
      }

      this.commitmentForm.startDate = null;
      this.commitmentForm.user.timeslotCollectionId = this.defaultTimeslotCollectionId;

      console.log("commitment_model_new: Created model", this.commitmentForm);
    },

    initConfigExistingCommitment() {
      // TODO: Does not support other users!
      console.log("initConfigExistingCommitment", this.goalId, this.commitmentId, this.memberId);
      // this.$models.commitment.with({ goalId: this.goalId }).subscribeNode( this.commitmentId )
      this.commitmentForm = this.$api.commitment_model_existing({
        member_id: this.memberId,
        commitment_id: this.commitmentId,
        goal_id: this.goalId
      })
      console.log("commitment_model_existing: Created model", this.commitmentForm);

      // TODO: SYNC:
      // commitmentForm.meta.name
      // commitmentForm.type
    },

    resetConfig() {
      this.commitmentForm = {
        meta: { name: '' },
        type: null,
        committedTime: 100 * 3600,
        picture: '',
      };
    },

    validatedStartAndEndDate() {

      // TODO: move validation to actions.js?
      console.log('validate', this.commitmentForm.startDate, this.commitmentForm.endDate)

      let startDateIsValid = this.commitmentForm.startDate && this.commitmentForm.startDate.isValid();
      let endDateIsValid = this.commitmentForm.endDate && this.commitmentForm.endDate.isValid();

      /* Check if startDate or endDate is null */
      if ( !startDateIsValid && !endDateIsValid ) {
        if (!confirm('Are you sure you want to save this commitment without a start date and without a deadline?')) {
          return
        }
      }

      /* <date-selector> always returns a moment object */
      let currentDate = moment.currentDate();
      let startDate = startDateIsValid
                    ? this.commitmentForm.startDate
                    : null;

      let endDate = endDateIsValid
                    ? this.commitmentForm.endDate
                    : null;

      if ( endDate &&
           startDate &&
           startDate > endDate ) {
        alert('Deadline has to be after start date.')
        throw new Error('Invalid dates');
      }
      if ( endDate && currentDate > endDate ) {
        alert('Warning: Deadline lies in the past') // TODO: this.$messageBox
      }

      if ( this.commitmentForm.user.timeslotCollectionId === '<new>' ) {
        alert("<new> not implemented");
        throw new Error('NOT_IMPLEMENTED')
      }

      this.commitmentForm.startDate = startDate;
      this.commitmentForm.endDate = endDate;
    },

    // ---------> TODO:

    onClickSaveOrCreate() {

      console.log("commitmentForm", JSON.stringify( this.commitmentForm.$state, null, 2 ) )
      console.log("wizard", JSON.stringify( this.wizard, null, 2 ) )

      // TODO: hours planned
      //       wenn automatisch plannung:
      // ausgewählt => max time und target time setzen
      // wenn nicht => target time setzen
      // wizard.committing_daily: null,

      /* INFO: Currently not created via wizard
      if ( this.commitmentForm.type === 'BACKLOG' ) {
        this.onSaveOrCreateBacklog();
      }
      */

      if ( this.step === 'basics' ) {
        // We're still at the first page, we have ot create the commimentForm first
        this.initConfigNewCommitment()
      }

      if ( this.commitmentForm.type === 'HABIT' ) {
        // this.commitmentForm.habitNegation: 'DO', 'DONT'
        // this.commitmentForm.habitRepeatPattern: 'EVERY_DAY' (see habitRepeatOptions)
        // this.commitmentForm.habitRepeatDaily: 1
        // this.commitmentForm.habitWeekdays: 'x-x-x--'

        // TODO --> Erzeugt Sequence im Hintergrund (ohne Zeitbezug?)

        // alert('This type is currently not supported.')
      }

      if ( this.commitmentForm.type === 'AMOUNT' ) {
        // this.commitmentForm.amountType: null
        // this.commitmentForm.amountCurrent: 0
        // this.commitmentForm.amountTarget: 1000

        // alert('This type is currently not supported.')
      }

      // Set committed time to 999h for any other type then TIME
      if ( this.commitmentForm.type !== 'TIME_BASED_TASKLIST' ) {
        // this.commitmentForm.committedTime = null;

        // HACK: set committedTime until TASKLIST type is supported
        this.commitmentForm.committedTime = 999 * 60 * 60;
      }

      /* <HACK> */
      /* if ( this.commitmentForm.type === 'TIME_BASED_TASKLIST' ) {
        // Use TASKLIST now untile TIME_BASED_TASKLIST is supported
        this.commitmentForm.type = 'TASKLIST';
      } */
      /* </HACK> */

      // If "I am responsible" was selected, make sure assigend user is set to me
      if ( this.wizard.responsibility === 'ME' ) {
        this.commitmentForm.meta.assignedUserId = this.$models.user.defaultUserId;
      }

      // "I'll decide later" was selected, so set active to false
      if ( this.commitmentForm.timeslotCollectionId === null
        || this.wizard.start_setting === "LATER" ) {
        this.commimentForm.meta.active = false
      }

      // Set template reapeat according to user selection
      if ( this.wizard.sequence_repeat_setting === 'ONCE' ) {
        this.commitmentForm.templateRepeat = 1;
      }
      if ( this.wizard.sequence_repeat_setting === 'INFINITELY' ) {
        this.commitmentForm.templateRepeat = 1e99; // HACK
      }

      // When ASAP is selected, we use todays date as start date
      // Maybe in the future, we do something more sophisticated
      if ( this.wizard.start_setting === "ASAP" ) {
        this.commitmentForm.startDate = moment.currentDate();
      }

      // Set start date / end date to null if other options are selected
      if ( this.wizard.start_setting === "LATER" ) {
        this.commitmentForm.startDate = null;
      }
      if ( this.wizard.end_setting === "WHEN_DONE" ) {
        this.commitmentForm.endDate = null;
      }

      // Save Manual vs. Automatic planning
      // TODO: Testen...
      if ( this.wizard.planning_strategy === 'AUTOMATIC' ) {
        // this.commitmentForm.committedTimeDaily = this.commitmentForm.committedTimeDaily;
        this.commitmentForm.committedTimePerDay = this.commitmentForm.committedTimeDaily;
        // this.commimentForm.meta.active = true
      }
      if ( this.wizard.planning_strategy === 'MANUALLY' ) {
        this.commitmentForm.committedTimePerDay = null;
        this.commitmentForm.committedTimeDaily = this.commitmentForm.committedTimeDaily;
        // this.commimentForm.meta.active = false
      }

      // Check if dates make sense
      try {
        this.validatedStartAndEndDate()
      } catch (e) {
        console.warn("Getting commitment data failed", e);
      }

      // TODO: Alle prio idx updaten
      // commimentForm.meta.prioidx

      console.log("*** Saving commitment with data", this.commitmentForm);

      let create_sequence_after_save = false;
      if ( this.commitmentForm.sequenceId === 'NEW' ) {
        this.commitmentForm.sequenceId = this.$models.sequence._get_uid();
        create_sequence_after_save = true;
      }

      this.commitmentForm.write_with_meta().then(commitment_id => {
        this.$emit('saved', this.commitmentForm);

        if ( create_sequence_after_save ) {
          this.onCreateNewSequenceFromExistingId( this.commitmentForm.sequenceId )
        }
      });

      this.onDone();
    },

    /*
    onSaveOrCreateBacklog() {
      console.log("onSaveOrCreateBacklog")

      // We don't have to create user settings
      this.commitmentForm.meta.assignedUserId = MAGIC_UID_TEAM;
      this.commitmentForm.startDate = null;
      this.commitmentForm.endDate = null;

      this.commitmentForm.write_with_meta().then(commitment_id => {
        this.$emit('saved', this.commitmentForm);
      });

      this.onDone();
    },
    */

    onCreateNewSequenceFromExistingId( sequence_id ) {
      // TODO: Move to mixin / actions
      let sortidx = 100; // TODO
      let user_id = this.$models.user.defaultUserId;

      this.$prompt('Please enter sequence name', 'New Sequence', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        closeOnClickModal: false,
      }).then(({ value }) => {
        let form = this.$models.sequence.new_from_template({ name: value, user_id })
        form.sortidx = sortidx;
        form.write().then(id => {
          this.$router.push( '/sequence/' + id + '/editor' );
        })
      }).catch();
    },
  },
}
</script>

<style>
.commitment-config-wizard .el-form-item {
  margin-bottom: 10px;
}
.commitment-config-wizard .commitment-picture {
  display: block;
  background: #9a9a9a;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: calc(116px * 1.5);
  width: calc(170px * 1.5);
  float: right;
  color: white;
  margin-bottom: 1em;
  border-radius: 5px;
}
.commitment-config-wizard .wizard-buttons {
  margin-top: 1em;
  display: flex;
  justify-content: space-between;
}
.commitment-config-wizard .timeslot-collection-radio-group .el-radio__input.is-checked + .el-radio__label {
  color: unset;
}
</style>
